import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'sticky',
      zIndex: 10,
      top: 0,
      backgroundColor: COLORS.neutral.white,
    },
    titleWrapper: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: theme.shape.borderGray70,
    },
    title: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      cursor: 'pointer',
    },
    buttonBack: {
      padding: theme.spacing(1),
      margin: theme.spacing(-1, 0, -1, -1), // compensate for the padding, but leave the gap with the title

      '& svg': {
        fontSize: theme.typography.pxToRem(12),
        color: COLORS.gray.black,
      },
    },
  }),
  { name: 'PromptMenuHeader' }
);
